import { get as getCookie } from 'js-cookie';
import type { InitRumConfig } from '@adv-frontend/yastore-modules/lib';

interface RumOptions {
    platform: 'touch' | 'desktop';
    env: string;
    requestId: string;
}

export const getRumConfig = ({ platform, env, requestId }: RumOptions): InitRumConfig => {
    return {
        env,
        uid: getCookie('yandexuid') ?? '',
        tld: 'ru',
        reqid: requestId,
        slots: [],
        region: '',
        project: 'yastore-checkout',
        platform,
    };
};
